import request from '@/utils/request';

/**
 * @description 查询角色权限列表
 * @param roleName
 * @param pageNum
 * @param pageSize
 */
function queryRolePermissionListList({ roleName, pageNum, pageSize } = {}) {
  return request({
    url: 'permission/pageQueryRolePermissionList',
    method: 'get',
    params: {
      roleName,
      pageNum,
      pageSize
    }
  });
}

/**
 * @description 查询角色列表(用于其他页面的搜索参数)
 */
function queryRoleList() {
  return request({
    url: 'permission/queryRoleList',
    method: 'get',
  });
}

/**
 * @description 查询权限列表
 */
function queryPermissionList() {
  return request({
    url: 'permission/queryPermissionList',
    method: 'get'
  });
}

/**
 * @description 更新角色权限
 * @param roleId
 * @param permissionIds
 */
function bindRolePermission({ roleId, permissionIds } = {}) {
  return request({
    url: 'permission/bindRolePermissions',
    method: 'post',
    data: {
      roleId,
      permissionIds
    }
  });
}

export default {
  queryRolePermissionListList,
  queryRoleList,
  queryPermissionList,
  bindRolePermission
};
